import { useEffect, useMemo, useState } from "react";

import {
    getSupportStats,
    getSupportTickets,
    deleteSupportTicket,
} from "../services/supportApi";

import SupportHeader from "../components/support/SupportHeader";
import SupportStats from "../components/support/SupportStats";
import SupportFilters from "../components/support/SupportFilters";
import SupportTable from "../components/support/SupportTable";

import "../css/Support.css";

function Support() {

    const [tickets, setTickets] = useState([]);
    const [stats, setStats] = useState({});
    const [loading, setLoading] = useState(true);

    const [filters, setFilters] = useState({
        search: "",
        status: "",
        priority: "",
        category: "",
    });

    const loadData = async () => {

        try {

            setLoading(true);

            const [statsRes, ticketsRes] = await Promise.all([
                getSupportStats(),
                getSupportTickets(),
            ]);

            setStats(statsRes.data || {});
            setTickets(ticketsRes.data.tickets || []);

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadData();

    }, []);

    const handleFilterChange = (key, value) => {

        setFilters((prev) => ({
            ...prev,
            [key]: value,
        }));

    };

    const filteredTickets = useMemo(() => {

        let data = [...tickets];

        if (filters.search) {

            const search = filters.search.toLowerCase();

            data = data.filter((ticket) =>
                ticket.ticketId?.toLowerCase().includes(search) ||
                ticket.subject?.toLowerCase().includes(search)
            );

        }

        if (filters.status) {

            data = data.filter(
                (ticket) => ticket.status === filters.status
            );

        }

        if (filters.priority) {

            data = data.filter(
                (ticket) => ticket.priority === filters.priority
            );

        }

        if (filters.category) {

            data = data.filter(
                (ticket) => ticket.category === filters.category
            );

        }

        return data;

    }, [tickets, filters]);

    return (

        <div className="support-page">

            <SupportHeader reload={loadData} />

            <SupportStats
                stats={stats}
            />

            <SupportFilters
                filters={filters}
                onChange={handleFilterChange}
            />

            <SupportTable
                tickets={filteredTickets}
                loading={loading}
                onDelete={deleteSupportTicket}
                reload={loadData}
            />

        </div>

    );

}

export default Support;